import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pinterest-scheduler")({
	beforeLoad: () => {
		throw redirect({ to: "/channels/pinterest" });
	},
});
